import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ui/component/Button.tsx';
import { Modal } from 'ui/component/Modal.tsx';

type Props = {
  isOpen: boolean;
  message: string;
  title?: string;
  value: string;
  onChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
};

export const PromptDialog: React.FC<Props> = ({ isOpen, message, title, value, onChange, onConfirm, onCancel, loading, confirmLabel, cancelLabel }) => {
  const { t } = useTranslation();
  return (
    <Modal title={title ? <h4>{title}</h4> : undefined} isOpen={isOpen} onClose={onCancel}>
      <div className="flex w-[450px] flex-col gap-4">
        <p className="text-center">{message}</p>
        <input className="w-full rounded border border-gray-300 p-2 focus:border-blue-400 focus:outline-none" value={value} onChange={(e) => onChange(e.target.value)} autoFocus />
        <div className="mt-4 flex w-full gap-4">
          <Button onClick={onCancel} className="blue-outlined" disabled={loading}>
            {cancelLabel ?? t('actions.back')}
          </Button>
          <Button loading={loading} onClick={onConfirm} className="blue">
            {confirmLabel ?? t('actions.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
